<template>
  <time class="countdown-clock">{{ display }}</time>
</template>

<script>
import { intervalToDuration } from "date-fns";
import toDate from "date-fns-tz/toDate";
export default {
  name: "CountdownClock",
  props: {
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      now: new Date(),
      tick: null,
    };
  },
  computed: {
    remaining() {
      const end = toDate(this.end, {
        timeZone: "Europe/London",
      });

      return intervalToDuration({
        start: this.now,
        end,
      });
    },
    display() {
      const hours = this.remaining.hours.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const mins = this.remaining.minutes.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const secs = this.remaining.seconds.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      return `${hours}:${mins}:${secs}`;
    },
  },
  mounted() {
    this.tick = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.countdown-clock {
  color: $color-white;
  font-family: $heading-font-family;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: 8px;
  display: block;
  text-align: center;

  @include respond-above(md) {
    letter-spacing: 25px;
  }
}
</style>
